export function wait(time) {
    return new Promise((response, reject) => {
        setTimeout(() => {
            response();
        }, time);
    })
}